var exports = {
  "L": "xe533113f--e4a47a--loading",
  "E": "xe533113f--e4a47a--overlap",
};

module.exports = exports;
